import React from "react";

const Ribbon = ({ viewBox = "0 0 24 36.89", color = "#fff", ...rest }) => {
  return (
    <svg viewBox={viewBox} {...rest}>
      <circle
        cx="12"
        cy="12"
        r="10.5"
        fill="none"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M27,35a20.52,20.52,0,0,0,5.5,1.14A20.52,20.52,0,0,0,38,35V48l-5.5-5.42L27,48Z"
        transform="translate(-20.5 -13.5)"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />
      <polyline
        points="7 12.66 9.5 15.4 16.5 8.74"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Ribbon;
